import { EDIT_TAG, REMOVE_TAG, SET_TAGS } from "./mutation-types";
import { RESET } from "../../mutation-types";
import api from "@/application";

const actions = {
  async createTag({ commit }, tagData) {
    try {
      const response = await api.tags.createTag(tagData);
      commit(SET_TAGS, response.data);
    } catch (e) {
      throw new Error(e);
    }
  },

  async editTag({ commit }, { tagId, tagData }) {
    try {
      await api.tags.editTag(tagId, tagData);
      commit(EDIT_TAG, tagData);
    } catch (e) {
      throw new Error(e);
    }
  },

  async deleteTag({ commit }, tagId) {
    try {
      await api.tags.deleteTag(tagId);
      commit(REMOVE_TAG, tagId);
    } catch (e) {
      throw new Error(e);
    }
  },

  async updateTagPriority({ commit, state }, priorityData) {
    const initialTagPriority = state.tags;
    try {
      commit(SET_TAGS, priorityData);
      await api.tags.updateTagPriority(priorityData);
    } catch (e) {
      commit(SET_TAGS, initialTagPriority);
      throw new Error(e);
    }
  },

  async tagLots(_, lotsData) {
    try {
      await api.tags.tagLots(lotsData);
    } catch (e) {
      throw new Error(e);
    }
  },

  async untagLots(_, lotsData){
    try {
      await api.tags.untagLots(lotsData);
    } catch (e) {
      throw new Error(e);
    }
  },

  resetTags({ commit }) {
    commit(RESET);
  },
};

export default actions;
